import React, { useState, useEffect } from "react";
import { ReleaseState, StoreState } from "@type/models/store";
import { useDispatch, useSelector } from "react-redux";
import { DatePicker, Tooltip } from "antd";
import AsyncSelect from "react-select/async";
import {
  getPrimaryArtistsOptionsFromApi,
  getCopyrightPOptionsFromApi,
  getLicensorOPtionsFromApi,
  getFeatureOptionsFromApi,
  getLableNameOptionsFromApi,
} from "../../../hooks/useOverlay";
import { Genre } from "../../../actions";
import { FetchAndDispatchActions } from "../dispatch-files/fetch-dispatch";
import dayjs from "dayjs";
import {
  getCountryList,
  getGenderList,
  getIpAddress,
  getMemberTypeList,
  getRoles,
  saveCopyrightP,
  saveLabel,
  saveLicensor,
  saveMember,
} from "../../../actions/user";
import "../../../assets/scss/components/track-overlay.scss";
import "../../../assets/scss/components/modal.scss";
import checkDateValidation, { Actions } from "../../../utils";
import { COOKIE_PARAMS, REACT_IMAGE_URL } from "../../../constants";
import { LabelModal } from "../../../components/modals/label";
import { MemberModal } from "../../../components/modals/member";
import Select from "react-select";
import LicensorModel from "../../../components/modals/licensor";
import { Backend } from "shared-types";
import useAuth from "../../../hooks/useAuth";
import { CopyrightPModal } from "../../../components/modals/copyright_p";
import { CopyrightCModal } from "../../../components/modals/copyright_c";

type OptionType = {
  value: string;
  label: string;
};

interface FormData {
  avatar_file?: string;
  releaseTitle?: string;
  copyrightP?: string;
  versionSubtitle?: string;
  copyRightC?: string;
  primaryArtists: OptionType[];
  year?: string;
  featureArtists: OptionType[];
  ean_code?: string;
  upc_code?: string;
  genre?: [];
  subgenre?: string;
  catalogNo?: string;
  labelName?: string;
  PhisicalReleaseDate?: string;
  format?: OptionType[];
  productionYear?: string;
  series?: string;
  licensor?: OptionType[];
}

let initialFormData = {
  avatar_file: "",
  releaseTitle: "",
  versionSubtitle: "",
  primaryArtists: [],
  featureArtists: [],
  ean_code: "",
  upc_code: "",
  genre: "",
  subgenre: "",
  labelName: "",
  PhisicalReleaseDate: undefined,
  format: "",
  copyrightP: "",
  productionYear: "",
  copyRightC: "",
  catalogNo: "",
  licensor: "",
};

interface Props {
  handleSubmission: (field: string, data: FormData) => void;
  callFunction: boolean;
  localStorageCleared: boolean;
  clearForm: boolean;
}

const loadFormDataFromLocalStorage = () => {
  const savedData = localStorage.getItem("releaseFormData");
  return savedData ? JSON.parse(savedData) : initialFormData;
};

const ReleaseInfo: React.FC<Props> = ({
  handleSubmission,
  callFunction,
  localStorageCleared,
  clearForm,
}) => {
  const dispatch = useDispatch();
  const { formate } = useSelector((state: StoreState) => state.suggestion);
  const { releaseInfo } = useSelector(
    (state: ReleaseState) => state.releaseInfo
  );
  const [genreList, setGenreList] = useState<OptionType[]>([]);
  const [subGenreList, setSubGenreList] = useState<OptionType[]>([]);
  const [formData, setFormData] = useState<any>(initialFormData);
  const [uploadedImage, setUploadedImage] = useState<string>(
    `${REACT_IMAGE_URL}/static/images/coverart-placeholder.svg`
  );
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [showModal, setShowModal] = useState<any>({
    label: false,
    member: false,
    licensor: false,
    copyrightP: false,
    copyrightC: false,
  });
  const [memberModel, setMemberModel] = useState<any>({});
  const [licensorModel, setLicensorModel] = useState<any>({});
  const [labelModel, setLabelModel] = useState<any>({});
  const [ip, setIp] = useState("");
  const [memberTypeList, setMemberTypeList] = useState<any>([]);
  const [genderList, setGenderList] = useState<any>([]);
  const [countryList, setCountryList] = useState<any>([]);
  const [roleList, setRoleList] = useState<Backend.T_MemberRole[]>([]);
  const { user } = useAuth() as any;
  const [copyrightPModel, setcopyrightPModel] = useState<any>({});
  const [copyrightCModel, setcopyrightCModel] = useState<any>({});

  const main = async () => {
    let genreRes = await Genre.getTopGenre();
    if (genreRes) {
      const formattedGenres: OptionType[] = genreRes.map((genre) => ({
        label: genre.title,
        value: genre.id.toString(),
      }));
      setGenreList(formattedGenres);
    }
  };

  const validateProductionYear = (value: string): string | null => {
    const currentYear = new Date().getFullYear();
    const validYearRegex = /^\d{4}$/;
    const upperLimit = currentYear + 30;

    if (!value || !validYearRegex.test(value)) {
      return "Please enter a valid production year in YYYY format.";
    }

    const enteredYear = parseInt(value, 10);
    if (enteredYear > upperLimit) {
      return "Invalid production year.";
    }
    return null;
  };

  const handleInputChange = (name: string, value: string) => {
    let errorMessage = "";

    if (name === "productionYear") {
      errorMessage = validateProductionYear(value) ?? "";
    } else if (name === "ean_code" || name === "upc_code") {
      errorMessage = validateCode(name, value);
    }

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: errorMessage,
    }));

    setFormData((prevFormData: any) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const validateCode = (name: string, code: string) => {
    const expectedLength = name === "ean_code" ? 13 : 12;
    const isValidLength = code.length === expectedLength;
    const containsOnlyNumbers = /^\d+$/.test(code);

    return containsOnlyNumbers
      ? isValidLength
        ? ""
        : `Invalid code or It should be ${expectedLength} digits long.`
      : "Contain only numeric digits.";
  };

  const handleMemberAddAction = (standard_role_id: number = 43) => {
    setMemberModel({
      id: 0,
      validate: true,
      title: "",
      alias: "",
      used_name: 1,
      member_type_id: 1,
      standard_role_id: standard_role_id,
      gender_id: 1,
      tag_status_id: 1,
      member_url: "",
      birth_place: "",
      death_place: "",
      img_path: "http://img.cugate.com",
      img_34: 0,
      img_64: 0,
      img_174: 0,
      img_300: 0,
      img_600: 0,
      img_orgn: 0,
      bio_url: "",
      fan_url: "",
      merch_url: "",
      trash_status: 0,
      register_from: 2,
      duplicate_group_id: 0,
      register_ip: ip,
      avatar: "",
      action: Actions.add,
      message: "",
    });
    setShowModal({ ...showModal, member: true });
  };

  const handleLicensorAddAction = () => {
    setLicensorModel({
      id: 0,
      validate: true,
      title: "",
      dba: "",
      parent_id: !user.company ? 2 : user.company,
      level: 2,
      country_id: undefined,
      state: "",
      city: "",
      addr: "",
      url: "",
      zip_code: "",
      tel: "",
      fax: "",
      email: "",
      register_from: !user.company ? 2 : user.company,
      action: Actions.add,
      message: "",
    });
    setShowModal({ ...showModal, licensor: true });
  };

  const handleLabelAddAction = () => {
    setLabelModel({
      id: 0,
      validate: true,
      title: "",
      series_code: "",
      comments: "",
      action: Actions.add,
      message: "",
    });
    setShowModal({ ...showModal, label: true });
  };

  const handleCloseModal = () => {
    setShowModal({
      label: false,
      artist: false,
      composer: false,
      copyrightP: false,
      copyrightC: false,
    });
  };

  const handleFileInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      const fileInput = e.target.files;
      if (fileInput && fileInput.length > 0) {
        const file = fileInput[0];
        var reader = new FileReader();
        reader.onload = function (ee: any) {
          setFormData({
            ...formData,
            avatar_file: file,
            avatar: ee.target.result,
          });
        };
        reader.readAsDataURL(file);
      }
    }
  };

  const resetForm = () => {
    setFormData(initialFormData);

    setUploadedImage(
      `${REACT_IMAGE_URL}/static/images/coverart-placeholder.svg`
    );
    setErrors({});
  };

  const handleLabelSaveAction = async (event: {
    currentTarget: any;
    preventDefault: () => void;
    stopPropagation: () => void;
  }) => {
    const form = event.currentTarget;
    event.preventDefault();
    if (form.checkValidity() === false) {
      event.stopPropagation();
      setLabelModel({ ...labelModel, validate: false, message: "" });
    } else {
      setLabelModel({ ...labelModel, validate: true, message: "" });
      saveLabel({
        ...labelModel,
        action:
          labelModel.action === Actions.add
            ? "add"
            : labelModel.action === Actions.edit
              ? "edit"
              : "delete",
        client_id: 2,
      }).then((res: any) => {
        if (res.result.status) {
          setLabelModel({
            ...labelModel,
            title: res.result.status === 2 ? "" : labelModel.title,
            alias: res.result.status === 1 ? "" : labelModel.alias,
            message: res.result.message,
            validate: true,
          });
        } else {
          if (labelModel.action === Actions.add) {
            dispatch({
              type: "SET_ADDED_STATUS",
              payload: "label",
            });
          }
          setShowModal({ ...showModal, label: false });
        }
      });
    }
  };

  const handleLicensorSaveAction = async (event: {
    currentTarget: any;
    preventDefault: () => void;
    stopPropagation: () => void;
  }) => {
    const form = event.currentTarget;
    event.preventDefault();
    if (form.checkValidity() === false) {
      event.stopPropagation();
      setLicensorModel({ ...licensorModel, validate: false, message: "" });
      return;
    } else {
      setLicensorModel({ ...licensorModel, validate: true, message: "" });
      saveLicensor({
        ...licensorModel,
        action: "add",
      }).then((res: any) => {
        if (res.result.status) {
          setLicensorModel({
            ...licensorModel,
            message: res.result.message,
            validate: true,
          });
        } else {
          if (labelModel.action === Actions.add) {
            dispatch({
              type: "SET_ADDED_STATUS",
              payload: "licensor",
            });
          }
          setShowModal({ ...showModal, licensor: false });
        }
      });
    }
  };

  const handleSubmit = async () => {
    const validationErrors: Record<string, string> = {};

    if (!formData.avatar_file) {
      validationErrors.avatar_file = "Please select a file.";
    }

    if (!formData.releaseTitle) {
      validationErrors.releaseTitle = "Please fill out this field.";
    }

    if (!formData.genre) {
      validationErrors.genre = "Please fill out this field.";
    }

    if (!formData.format) {
      validationErrors.format = "Please fill out this field.";
    }

    if (!formData.labelName) {
      validationErrors.labelName = "Please fill out this field.";
    }

    if (!formData.primaryArtists?.length) {
      validationErrors.primaryArtists = "Please fill out this field.";
    }

    if (!formData.subgenre) {
      validationErrors.subgenre = "Please fill out this field.";
    }

    if (!formData.productionYear) {
      validationErrors.productionYear = "Please fill out this field.";
    }

    if (!formData.copyrightP) {
      validationErrors.copyrightP = "Please fill out this field.";
    }

    if (!formData.copyRightC) {
      validationErrors.copyRightC = "Please fill out this field.";
    }

    if (!formData.PhisicalReleaseDate) {
      validationErrors.PhisicalReleaseDate = "Please fill out this field.";
    }

    if (formData.ean_code && errors.ean_code) {
      validationErrors.ean_code = "Please enter a valid EAN.";
    }

    if (formData.upc_code && errors.upc_code) {
      validationErrors.upc_code = "Please enter a valid UPC.";
    }

    saveFormDataToLocalStorage();
    if (validationErrors && Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    } else {
      handleSubmission("releaseInfo", formData);
    }
  };

  const saveFormDataToLocalStorage = () => {
    localStorage.setItem("releaseFormData", JSON.stringify(formData));
  };

  const handleMemberSaveAction = async (event: {
    currentTarget?: any;
    preventDefault: () => void;
    stopPropagation: () => void;
  }) => {
    const form = event.currentTarget;
    event.preventDefault();

    const dateValidationMessage = checkDateValidation(
      memberModel.birth_date,
      memberModel.death_date
    );
    if (
      form.checkValidity() === false ||
      ((memberModel.avatar === null || memberModel.avatar === "") &&
        memberModel.action === Actions.add) ||
      dateValidationMessage
    ) {
      event.stopPropagation();
      setMemberModel({ ...memberModel, validate: false, message: "" });
    } else {
      setMemberModel({ ...memberModel, validate: true, message: "" });
      saveMember({
        ...memberModel,
        action:
          memberModel.action === Actions.add
            ? "add"
            : memberModel.action === Actions.edit
              ? "edit"
              : "delete",
      }).then((res: any) => {
        if (res.result.status) {
          setMemberModel({
            ...memberModel,
            message: res.result.message,
            validate: true,
          });
        } else {
          if (memberModel.action === Actions.add) {
            dispatch({
              type: "SET_ADDED_STATUS",
              payload:
                memberModel.standard_role_id === 43 ? "artist" : "composer",
            });
          }
          setShowModal({ ...showModal, member: false });
        }
      });
    }
  };

  const handleCopyRightPAddAction = () => {
    setcopyrightPModel({
      id: 0,
      validate: true,
      title: "",
      dba: "",
      parent_id: !user.company ? 2 : user.company,
      level: 2,
      country_id: undefined,
      state: "",
      city: "",
      addr: "",
      url: "",
      zip_code: "",
      tel: "",
      fax: "",
      email: "",
      register_from: !user.company ? 2 : user.company,
      action: Actions.add,
      message: "",
    });
    setShowModal({ ...showModal, copyrightP: true });
  };

  const handleCopyRightCAddAction = () => {
    setcopyrightCModel({
      id: 0,
      validate: true,
      title: "",
      dba: "",
      parent_id: !user.company ? 2 : user.company,
      level: 2,
      country_id: undefined,
      state: "",
      city: "",
      addr: "",
      url: "",
      zip_code: "",
      tel: "",
      fax: "",
      email: "",
      register_from: !user.company ? 2 : user.company,
      action: Actions.add,
      message: "",
    });
    setShowModal({ ...showModal, copyrightC: true });
  };

  const handleCopyRightPSaveAction = async () => {
    saveCopyrightP({
      ...copyrightPModel,
      action: "add",
    }).then((res: any) => {
      if (res.result.status) {
        setcopyrightPModel({
          ...copyrightPModel,
          message: res.result.message,
          validate: true,
        });
      } else {
        if (copyrightPModel.action === Actions.add) {
          dispatch({
            type: "SET_ADDED_STATUS",
            payload: "copyrightP",
          });
        }
        setShowModal({ ...showModal, copyrightP: false });
      }
    });
  };

  const handleCopyRightCSaveAction = async () => {
    saveCopyrightP({
      ...copyrightCModel,
      action: "add",
    }).then((res: any) => {
      if (res.result.status) {
        setcopyrightPModel({
          ...copyrightCModel,
          message: res.result.message,
          validate: true,
        });
      } else {
        if (copyrightCModel.action === Actions.add) {
          dispatch({
            type: "SET_ADDED_STATUS",
            payload: "copyrightC",
          });
        }
        setShowModal({ ...showModal, copyrightC: false });
      }
    });
  };

  function debounce(func: Function, delay: number) {
    let timeoutId: NodeJS.Timeout;
    return function debounced(...args: any[]) {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func(...args);
      }, delay);
    };
  }

  useEffect(() => {
    getMemberTypeList({}).then((res: any) => {
      setMemberTypeList(res.result);
    });
    getGenderList({}).then((res: any) => {
      setGenderList(res.result);
    });
    getCountryList({}).then((res: any) => {
      setCountryList(res?.countries);
    });
    getRoles().then((res: any) => {
      setRoleList(res);
    });

    getIpAddress()
      .then((res) => setIp(res))
      .catch(console.warn);

    let old = window.localStorage.getItem(COOKIE_PARAMS.SELECTED.TRACK);
    let arr = JSON.parse(old ? old : "[]");
    dispatch({
      type: "SET_SELECTED_TRACKS",
      payload: arr,
    });

    main();

    FetchAndDispatchActions(dispatch)
      .then((result) => {
        console.log(result);
      })
      .catch((error) => {
        console.log(error);
      });

  }, []);

  useEffect(() => {
    const main = async () => {
      let subGenreRes = await Genre.getTopSubGenre(formData.genre.value);
      if (subGenreRes) {
        const formattedSubGenres: OptionType[] = subGenreRes.map((genre) => ({
          label: genre.title,
          value: genre.id.toString(),
        }));
        setSubGenreList(formattedSubGenres);
        setFormData((prevFormData: FormData) => ({
          ...prevFormData,
          subgenre: releaseInfo.subgenre ? { ...releaseInfo.subgenre } : "",
        }));
      }
    };
    if (formData.genre.value) {
      main();
    }
  }, [formData.genre?.value]);

  useEffect(() => {
    if (callFunction) {
      handleSubmit();
    }
  }, [callFunction]);

  useEffect(() => {
    resetForm();
  }, [clearForm]);

  useEffect(() => {
    const savedFormData = loadFormDataFromLocalStorage();
    setFormData(savedFormData);
  }, [localStorageCleared]);

  useEffect(() => {
    if (releaseInfo?.releaseTitle) {
      setFormData((prevErrors: any) => ({
        ...prevErrors,
        ...releaseInfo,
      }));
    }
  }, [releaseInfo]);


  return (
    <div>
      <div className="container track-overlay-wrapper p-2">
        <div className="flex sm:flex-col">
          <div className="col-12 col-xl-4">
            <div className="tw-font-bold tw-text-[#999999]">Cover art</div>
            <div className="flex items-start flex-column">
              <input
                type="file"
                name="avatar_file"
                id="releaseArtworkUpload"
                className="display-none inputfile inputfile-3 w-0.1 h-0.1 opacity-0 overflow-hidden absolute -z-1"
                onChange={handleFileInputChange}
              />

              <label
                htmlFor="releaseArtworkUpload"
                id="releaseArtworkUploadLabel"
                className="upload-image-setup p-0"
              >
                <img
                  src={formData.avatar ? formData.avatar : uploadedImage}
                  className="w-full border border-dashed border-gray-300"
                  alt="Cover Art"
                />
              </label>
              {errors.avatar_file && !formData.avatar_file && (
                <div className="text-danger">{errors.avatar_file}</div>
              )}
            </div>
          </div>

          <div className="col-12 col-xl-4">
            <div className="fields-wrapper flex-grow-shrink flex justify-content-between items-center tw-gap-[20px] tw-my-[20px]">
              <label>Release Title *</label>
              <input
                type="text"
                placeholder="Please Enter Title"
                onChange={(e) =>
                  handleInputChange("releaseTitle", e.target.value)
                }
                value={formData.releaseTitle}
              />
              {errors.releaseTitle && !formData.releaseTitle && (
                <div className="text-danger">{errors.releaseTitle}</div>
              )}
            </div>

            <div className="fields-wrapper flex-grow-shrink flex justify-content-between items-center tw-gap-[20px] tw-my-[20px]">
              <label>
                Primary Artist * (
                <span
                  className="text-purple-600 underline underline-click-event"
                  onClick={() => handleMemberAddAction(43)}
                >
                  Add New
                </span>
                )
              </label>
              <AsyncSelect
                className={"select-search basic-single"}
                classNamePrefix="select"
                loadOptions={debounce(getPrimaryArtistsOptionsFromApi, 500)}
                placeholder="Please select Primary Artist"
                isMulti={true}
                value={formData.primaryArtists}
                onChange={(items: any) =>
                  setFormData({
                    ...formData,
                    primaryArtists: items,
                  })
                }
                isSearchable={true}
              />
              {formData.primaryArtists?.length === 0 &&
                errors.primaryArtists && (
                  <div className="text-danger">{errors.primaryArtists}</div>
                )}
            </div>

            <div className="fields-wrapper flex-grow-shrink flex justify-content-between items-center tw-gap-[20px] tw-my-[20px]">
              <label>Genre *</label>
              <div>
                <Select
                  className="select-search basic-single"
                  classNamePrefix="select"
                  placeholder="Please select Genre"
                  isMulti={false}
                  value={formData.genre}
                  onChange={(item: any) =>
                    setFormData({ ...formData, genre: item, subgenre: "" })
                  }
                  options={genreList}
                  isSearchable={true}
                />
              </div>
              {!formData.genre && errors.genre && (
                <div className="text-danger">{errors.genre}</div>
              )}
            </div>
            <div className="fields-wrapper flex-grow-shrink flex justify-content-between items-center tw-gap-[20px] tw-my-[20px]">
              <label>SubGenre *</label>
              <div>
                <Select
                  className="select-search basic-single"
                  classNamePrefix="select"
                  placeholder="Please select subgenre"
                  isMulti={false}
                  value={formData.subgenre}
                  onChange={(item: any) =>
                    setFormData({ ...formData, subgenre: item })
                  }
                  options={subGenreList}
                  isSearchable={true}
                />
              </div>
              {errors.subgenre && !formData.subgenre && (
                <div className="text-danger">{errors.subgenre}</div>
              )}
            </div>

            <div className="fields-wrapper flex-grow-shrink flex justify-content-between items-center tw-gap-[20px] tw-my-[20px]">
              <label className="label-title text-lg">
                {" "}
                Copy Right ℗ * (
                <span
                  className="text-purple-600 underline underline-click-event"
                  onClick={() => handleCopyRightPAddAction()}
                >
                  Add New
                </span>
                )
              </label>
              <Tooltip
                placement="top"
                title="The producer of the release is the rights owner that financed the recording of the tracks."
                trigger="hover"
              >
                <div>
                  <AsyncSelect
                    className="select-search basic-single"
                    classNamePrefix="select"
                    loadOptions={debounce(getCopyrightPOptionsFromApi, 500)}
                    placeholder="Please select copyright p"
                    isMulti={false}
                    value={formData.copyrightP}
                    onChange={(item: any) =>
                      setFormData({ ...formData, copyrightP: item })
                    }
                    isSearchable={true}
                  />

                  {errors.copyrightP && !formData.copyrightP && (
                    <div className="text-danger">{errors.copyrightP}</div>
                  )}
                </div>
              </Tooltip>
            </div>

            <div className="fields-wrapper flex-grow-shrink flex justify-content-between items-center tw-gap-[20px] tw-my-[20px]">
              <label className="label-title">
                {" "}
                Copy Right © * (
                <span
                  className="text-purple-600 underline underline-click-event"
                  onClick={() => handleCopyRightCAddAction()}
                >
                  Add New
                </span>
                ){" "}
              </label>
              <Tooltip
                placement="top"
                title="Enter the name of the artwork copyright owner."
                trigger="hover"
              >
                <div>
                  <AsyncSelect
                    className="select-search basic-single"
                    classNamePrefix="select"
                    loadOptions={debounce(getCopyrightPOptionsFromApi, 500)}
                    placeholder="Please select copyright c"
                    isMulti={false}
                    value={formData.copyRightC}
                    onChange={(item: any) =>
                      setFormData({ ...formData, copyRightC: item })
                    }
                    isSearchable={true}
                  />
                </div>
                {errors.copyRightC && !formData.copyRightC && (
                  <div className="text-danger">{errors.copyRightC}</div>
                )}
              </Tooltip>
            </div>

            <div className="fields-wrapper flex-grow-shrink flex justify-content-between items-center tw-gap-[20px] tw-my-[20px]">
              <label className="label-title">Format *</label>
              <Select
                className="select-search basic-single"
                classNamePrefix="select"
                placeholder="Please select Format"
                isMulti={false}
                value={formData.format}
                onChange={(item: any) =>
                  setFormData({ ...formData, format: item })
                }
                options={formate}
              />
              {!formData.format && errors.format && (
                <div className="text-danger">{errors.format}</div>
              )}
            </div>

            <div className="fields-wrapper flex-grow-shrink flex justify-content-between items-center tw-gap-[20px] tw-my-[20px]">
              <label>UPC</label>
              <input
                type="text"
                placeholder="Please enter UPC"
                value={formData.upc_code}
                onChange={(e: any) =>
                  handleInputChange("upc_code", e.target.value)
                }
              />
              {errors.upc_code && formData.upc_code.length !== 0 && (
                <div className="text-danger">{errors.upc_code}</div>
              )}
            </div>
          </div>

          <div className="col-12 col-xl-4">
            <div className="fields-wrapper flex-grow-shrink flex justify-content-between items-center tw-gap-[20px] tw-my-[20px]">
              <label>EAN</label>
              <input
                type="text"
                placeholder="Please enter EAN"
                value={formData.ean_code}
                onChange={(e: any) =>
                  handleInputChange("ean_code", e.target.value)
                }
              />
              {errors.ean_code && formData.ean_code.length !== 0 && (
                <div className="text-danger">{errors.ean_code}</div>
              )}
            </div>

            <div className="fields-wrapper flex-grow-shrink flex justify-content-between items-center tw-gap-[20px] tw-my-[20px]">
              <label> Catalog No </label>
              <input
                type="text"
                placeholder="Please enter catalog number"
                value={formData.catalogNo}
                onChange={(e) => handleInputChange("catalogNo", e.target.value)}
              />
            </div>

            <div className="fields-wrapper flex-grow-shrink flex justify-content-between items-center tw-gap-[20px] tw-my-[20px]">
              <label>
                licensor (
                <span
                  className="text-purple-600 underline underline-click-event"
                  onClick={() => handleLicensorAddAction()}
                >
                  Add New
                </span>
                )
              </label>
              <AsyncSelect
                className={"select-search basic-single"}
                classNamePrefix="select"
                loadOptions={debounce(getLicensorOPtionsFromApi, 500)}
                placeholder="Please enter licensor"
                isMulti={false}
                value={formData.licensor}
                onChange={(item: any) =>
                  setFormData({ ...formData, licensor: item })
                }
                isSearchable={true}
              />
            </div>

            <div className="fields-wrapper flex-grow-shrink flex justify-content-between items-center tw-gap-[20px] tw-my-[20px]">
              <label>Version/Subtitle</label>
              <input
                type="text"
                placeholder="Please enter Version/Subtitle"
                value={formData.versionSubtitle}
                onChange={(e) =>
                  handleInputChange("versionSubtitle", e.target.value)
                }
              />
            </div>

            <div className="fields-wrapper flex-grow-shrink flex justify-content-between items-center tw-gap-[20px] tw-my-[20px]">
              <label>
                Feature Artist (
                <span
                  className="text-purple-600 underline underline-click-event"
                  onClick={() => handleMemberAddAction(43)}
                >
                  Add New
                </span>
                )
              </label>

              <AsyncSelect
                className={"select-search basic-single"}
                classNamePrefix="select"
                loadOptions={debounce(getFeatureOptionsFromApi, 500)}
                placeholder="Please select Feature Artist"
                isMulti={true}
                value={formData.featureArtists}
                onChange={(item: any) =>
                  setFormData({ ...formData, featureArtists: item })
                }
                isSearchable={true}
              />
            </div>

            <div className="fields-wrapper flex-grow-shrink flex justify-content-between items-center tw-gap-[20px] tw-my-[20px]">
              <label>
                Label Name * (
                <span
                  className="text-purple-600 underline underline-click-event"
                  onClick={handleLabelAddAction}
                >
                  Add New
                </span>
                )
              </label>
              <Tooltip
                placement="top"
                title="Make sure the label spelling is the same for every release, and use the exact spelling as authorized by pre-authorisation platforms or services."
                trigger="hover"
                mouseLeaveDelay={0.5}
              >
                <div>
                  <AsyncSelect
                    className="select-search basic-single"
                    classNamePrefix="select"
                    loadOptions={debounce(getLableNameOptionsFromApi, 500)}
                    placeholder="Please select Label Name"
                    isMulti={false}
                    value={formData.labelName}
                    onChange={(item: any) =>
                      setFormData({ ...formData, labelName: item })
                    }
                    isSearchable={true}
                  />
                </div>

                {errors.labelName && !formData.labelName && (
                  <div className="text-danger">{errors.labelName}</div>
                )}
              </Tooltip>
            </div>

            <div className="fields-wrapper flex-grow-shrink flex justify-content-between items-center tw-gap-[20px] tw-my-[20px]">
              <label> Physical (original) release date * </label>
              <DatePicker
                aria-required
                className="w-100 remove-input-border px-1 py-0"
                // format={"DD-MM-YYYY"}
                value={
                  formData.PhisicalReleaseDate
                    ? dayjs(formData.PhisicalReleaseDate)
                    : dayjs()
                }
                onChange={(date, dateString) => {
                  setFormData({ ...formData, PhisicalReleaseDate: dateString });
                }}
              />

              {errors.PhisicalReleaseDate && !formData.PhisicalReleaseDate && (
                <div className="text-danger">{errors.PhisicalReleaseDate}</div>
              )}
            </div>

            <div className="fields-wrapper flex-grow-shrink flex justify-content-between items-center tw-gap-[20px] tw-my-[20px]">
              <label>Production Year *</label>
              <input
                type="text"
                placeholder="Please enter Production Year"
                value={formData.productionYear}
                onChange={(e) =>
                  handleInputChange("productionYear", e.target.value)
                }
              />
              {errors.productionYear && (
                <div className="text-danger">{errors.productionYear}</div>
              )}
            </div>
          </div>
        </div>

        <MemberModal
          mkey={"member-add"}
          show={showModal.member}
          model={memberModel}
          setModel={setMemberModel}
          closeModal={handleCloseModal}
          saveModal={handleMemberSaveAction}
          memberTypeList={memberTypeList}
          genderList={genderList}
          countryList={countryList}
          roleList={roleList}
        />
        <LabelModal
          mkey={"label-add"}
          show={showModal.label}
          model={labelModel}
          setModel={setLabelModel}
          closeModal={handleCloseModal}
          saveModal={handleLabelSaveAction}
        />

        <LicensorModel
          mkey={"licensor-add"}
          show={showModal.licensor}
          model={licensorModel}
          setModel={setLicensorModel}
          closeModal={handleCloseModal}
          saveModal={handleLicensorSaveAction}
          countryList={countryList}
        />

        <CopyrightPModal
          mkey={"copyrightP-add"}
          show={showModal.copyrightP}
          model={copyrightPModel}
          setModel={setcopyrightPModel}
          closeModal={handleCloseModal}
          saveModal={handleCopyRightPSaveAction}
        />

        <CopyrightCModal
          mkey={"copyrightC-add"}
          show={showModal.copyrightC}
          model={copyrightCModel}
          setModel={setcopyrightCModel}
          closeModal={handleCloseModal}
          saveModal={handleCopyRightCSaveAction}
        />
      </div>
    </div>
  );
};

export default ReleaseInfo;
